import Grid from '@mui/material/Grid';
import is from '@sindresorhus/is';

import { ContentHeadline, ContentWrapper } from '../../../../../design/components/containers/ContentWrapper';

import type { ContentWrapperProps } from '../../../../../design/components/containers/ContentWrapper';
import type { FunctionComponent, PropsWithChildren, ReactNode } from 'react';

type SidebarCardProps = {
    readonly backgroundColor?: ContentWrapperProps['backgroundColor'];
    readonly detailActions: ReactNode;
    readonly title: string;
};

export const SidebarCard: FunctionComponent<PropsWithChildren<SidebarCardProps>> = (props) => {
    const { backgroundColor, children, detailActions, title } = props;

    return (
        <ContentWrapper {...(is.string(backgroundColor) ? { backgroundColor } : {})}>
            <ContentHeadline actions={detailActions} text={title} />
            <Grid container={true} direction="column" px={3} py={2} rowGap={2}>
                {children}
            </Grid>
        </ContentWrapper>
    );
};
